import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "phieu-xuat-kho-vat-tu-table__footer-label"
}
const _hoisted_2 = {
  key: 1,
  class: "phieu-xuat-kho-vat-tu-table__footer-label"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "phieu-xuat-kho-vat-tu-table__footer-label-sub" }, "(bằng chữ)", -1)
const _hoisted_4 = {
  key: 0,
  class: "phieu-xuat-kho-vat-tu-table__footer-number"
}
const _hoisted_5 = {
  key: 1,
  class: "phieu-xuat-kho-vat-tu-table__footer-label"
}
const _hoisted_6 = { class: "phieu-xuat-kho-vat-tu-table__footer-label-sub" }

import { computed } from "vue";
import { normalizeTableRow } from "./composables/normalizeTableRow";
import { usePhieuXuatKhoTableCellApi } from "./composables/usePhieuXuatKhoTableCellApi";
import type { PhieuXuatKhoTableColumnId } from "./composables/usePhieuXuatKhoTableColumns";
import type { PhieuXuatKhoTableRow } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuFooterCell',
  props: {
    columnId: {},
    row: {}
  },
  setup(__props: any) {

const props = __props;

const api = usePhieuXuatKhoTableCellApi();
const normalized = computed(() => normalizeTableRow(props.row));

const formattedTotal = computed(() => {
  const total = api.isSummaryMode
    ? api.calcThanhTienTotal(normalized.value.footerMeta?.vatTuDaLay ?? [])
    : api.pickTotalAmount;

  return api.formatAmount(total);
});

const amountInWords = computed(() => {
  if (api.isSummaryMode) {
    return normalized.value.footerMeta?.tongTienBangChu ?? "";
  }

  return api.pickTotalText;
});

return (_ctx: any,_cache: any) => {
  return (_ctx.columnId === 'so_luong_xuat')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (normalized.value.kind === 'footer-total')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Tổng tiền "))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createTextVNode(" Tổng tiền "),
              _hoisted_3
            ]))
      ], 64))
    : (_ctx.columnId === 'thanh_tien')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (normalized.value.kind === 'footer-total')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(formattedTotal.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(amountInWords.value), 1)
              ]))
        ], 64))
      : _createCommentVNode("", true)
}
}

})